import React, { useEffect, useState } from 'react'
import { faRefresh } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ServiceWorkerUpdateNotification = () => {
  const [waitingServiceWorker, setWaitingServiceWorker] = useState<ServiceWorker | null>(null)
  const [isUpdateAvailable, setIsUpdateAvailable] = useState(false)

  useEffect(() => {
    const onSWUpdate = (registration: ServiceWorkerRegistration) => {
      if (registration.waiting) {
        setWaitingServiceWorker(registration.waiting)
        setIsUpdateAvailable(true)

        // Bloquer le scroll et les interactions sur la page
        document.body.classList.add('no-scroll')
      }
    }

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistration().then((registration) => {
      if (registration && registration.waiting) {
        onSWUpdate(registration)
      }
    })

    // Detecte quand l'utilisateur revient sur l'onglet
    document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      navigator.serviceWorker.getRegistration().then((registration) => {
        registration?.update()
      })
    }
    })
      
    window.addEventListener('swUpdate', (event: Event) => {
        const customEvent = event as CustomEvent
        onSWUpdate(customEvent.detail)
      })
    }

    navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload()
    })

    
    return () => {
      document.body.classList.remove('no-scroll')
    }
  }, [])

  const updateApp = () => {
    waitingServiceWorker?.postMessage({ type: 'SKIP_WAITING' })
  }

  if (!isUpdateAvailable) return null

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        zIndex: 99999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        pointerEvents: 'auto',
      }}
    >
      <div
        style={{
          backgroundColor: '#333',
          color: 'white',
          padding: '24px 32px',
          borderRadius: '10px',
          textAlign: 'center',
        }}
      >
        <p style={{ marginBottom: 16 }}>Une mise à jour est disponible. Veuillez recharger.</p>
        <button
          onClick={updateApp}
          style={{
            background: 'white',
            color: '#333',
            border: 'none',
            borderRadius: '4px',
            padding: '10px 16px',
            cursor: 'pointer',
            fontWeight: 'bold',
          }}
        >
          Recharger <FontAwesomeIcon icon={faRefresh} />
        </button>
      </div>
    </div>
  )
}

export default ServiceWorkerUpdateNotification
